import { TrackingFeature } from '../types/feature';

export const UKFeature: TrackingFeature = {
  enabledFacebookCapiV2: true,
  enabledTrackProductPageViewMoreThan3: true,
};
